<template>
    <div class="d-content">
        <keep-alive>
          <div class="main-container">
    <div class>
      <breadcrumb :list="breadcrumbList" />
      <tl-header type="h1">
        <div class="main-header">Payslips & IT sheet (All Employees)</div>
      </tl-header>
      <br />

      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <!-- <toast-message style="margin-bottom: 10px;" message="We are currently upgrading our system, Please check later." :isClosed="false" type="error" :isToastEnable="true" />     -->
      <!-- <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission && (role !=='EMPLOYEE' && role !=='HR')">
        You have only view permission.
      </div>  -->
      <!-- <section class="filters">
        <date-picker
          class="customwidth"
          :initialView="'month'"
          :formatDate="'MMMM-yyyy'"
          :maximumView="'year'"
          :minimumView="'month'"
          :datesDisabled="{from:new Date(new Date().setDate(new Date().getDate() - 1))}"
          @datevalue="(val)=>getFormattedMonth(val)"
          :value="month"
        />
      </section> -->

      <div v-if="showtable">
      <div class="row margintop-10 content-new">
        <div>
          <tl-radio  name="docType" label="Payslip" id="paySlip" value="paySlip" @change="docTypeChange"
            v-model="docType" />
        </div>
        <div>
          <tl-radio  name="docType" label="IT Sheet" id="ITSheet" value="ITSheet" @change="docTypeChange"
            v-model="docType" />
        </div>
        <div>
          <tl-radio  name="docType" label="Additional Sheet" id="additional_paySlip" value="additional_paySlip" @change="docTypeChange"
            v-model="docType" />
        </div>
      </div>
      <div class="row margintop-10 mb-10 content-new">
        <div>
          <tl-radio  name="employeeStatus" label="Active Employees" id="active" value="active" 
            v-model="employeeStatus" />
        </div>
        <div>
          <tl-radio  name="employeeStatus" label="In-Active Employees" id="inActive" value="inActive"
            v-model="employeeStatus" />
        </div>
      </div>
    </div>
      <div v-if="!showtable" class="reportDownloadLeft">
          <span>Month-Year</span>
          <tl-select class="reportDownloadLeftTextField" :options="payrollMonthOptions"
              placeholder="Year/Month" v-model="payslipMonthYear" @change="(val) => payslipMonthYear = val" />
      </div>
      <section v-if="showtable" class="filters">
        <date-picker class="customwidth" :initialView="'month'" :formatDate="'MMMM-yyyy'" :maximumView="'year'"
          :minimumView="'month'" :datesDisabled="{ from: new Date(new Date().setDate(new Date().getDate() - 1)) }"
          @datevalue="(val) => getFormattedMonth(val)" :value="month" />
      </section>

      <div class="row margin-t-m" >
        
          <div class="dropDownClass">
          <!-- <tl-select class="tl-select" label="Paygroup" labelText="name" v-model="paygroup" :multiple="true" :options="paygroupOptions"
            @change="(val) => paygroup = val" /> -->
            <tl-select v-if="showtable"  class="tl-select" label="Category" labelText="name" v-model="category" :multiple="false" :options="categoryOptions"
            @change="(val) => categoryFunction(val)" />
            <tl-select v-if="showtable"  v-show="subCategoryVisibleFlag" class="tl-select" label="sub-category" labelText="name" v-model="subCategory" :multiple="true" :options="subCategoryOptions"
            @change="(val) => subCategoryFunction(val)" />
        </div>
        <!-- <div class="col-3">
          <tl-select
            label="Criteria"
            v-model="criteria"
            :options="criteriaOptions"
            @change="(val) => {criteria = val;onSelectCriteria(val)}"
          />
        </div>
        <div class="col-3" v-if="subCriteriaLabel">
          <tl-select
            :label="subCriteriaLabel"
            labelText="name"
            v-model="subcriteria"
            :multiple="true"
            :options="subCriteriaList"
            @change="(val)=>subcriteria = val"
          />
        </div> -->
        
      </div>
      <div class="buttonsClass">
        <div  class="col-2 filterButton">
          <btn text="Apply Filters" type="secondary" class="btn-filter" @click="applyFilters"></btn>
        </div>
        <div v-if="!showtable"  class="col-2 filterButton">
          <btn text="Download Payslip" type="secondary" class="btn-filter" @click="reloadFunction"></btn>
        </div>
        <div v-if="showtable" class="col-3 filterButton">
          <btn :text="generateBulkText" type="primary" class="btn-filter" @click="downloadBulkPayslipsNew"></btn>
          <pop-up-message v-if="showModal" :message="responseMessage" btnText="OK"
          @back="downloadBulkPayslipsdetails()"></pop-up-message>
        </div>
      </div>
      <div class="searchsort margin-tb-l" >
        <!-- PL_2996 -->
        <search-dropdown
          label="Search Employee"
          v-model="searchText"
          placeholder="Please enter at least 3 characters"
          :employeeData="customEmpList"
          @getList="getEmployeesByName($event)"
          @empselected="(emp)=>selectedEmp(emp)"
        />

        <!-- Below code is comment because their no connection with data table  -->
        <!-- <div class="sorttext">
          <span>Sort By:</span>
        </div>&nbsp; &nbsp; &nbsp;
        <tl-select
          class="customwidth"
          :value="filterType.designation"
          :options="['Recently Joined', 'Admin', 'IT']"
        /> -->
      </div>
    </div>
    <!-- PL_2996 -->
    <!-- <div
      v-if="employeeList.length==0" 
    ><strong>No Data Available For The Above Criteria</strong></div> -->

    <!-- <div style="display: flex; gap: 10px;" v-show="(role =='EMPLOYEE' || role =='HR'|| role =='CLIENTADMIN') ">
      <div class="employeeDownload" @click="downloadEssPayslip()" v-show="!ifTeamleaderAnchorPermission">
        <img src="@/assets/download.svg"  class="downloadImg" />
        <span class="downloadText">Payslip</span>
      </div>
      <div class="employeeDownload" @click="downloadEssITSheet()" v-show="!ifTeamleaderAnchorPermission">
        <img src="@/assets/download.svg"  class="downloadImg" />
        <span class="downloadText">IT Sheet</span>
      </div>
      <div class="employeeDownload" @click="downloadEssITSheet()" v-show="!ifTeamleaderAnchorPermission">
        <img src="@/assets/download.svg"  class="downloadImg" />
        <span class="downloadText">YTD Report</span>
      </div>
    </div> -->
    <div v-if="employeeList.length && totalEmployees && showApplyFilter">{{employeeList.length}}&nbsp;/&nbsp; {{totalEmployees}}</div>
    <div class="table-div" v-if="employeeList.length && showApplyFilter" ref="table_div" @scroll="onScroll()">
      <data-table
        :columns="columnNames"
        :tableData="employeeList"
        :showinrow="false"
        :withForm="false"
        :disableEdit="false"
        :headcheckbox="false"
        :disable-delete="true"
        :actionbtn="true"
        :showinheader="false"
        :search="search"
        :icons="[
                   {url:require('@/assets/garbage.png'), method: 'up'},
                   {url:require('@/assets/garbage.png'), method: 'down'},
                   {url:require('@/assets/garbage.png'), method: 'deletee'}
                   ]"
      >
        <template v-slot:rowcontent="slotprops">
          <img
            class="sm-img"
            v-if="slotprops.value.column.key=='imgSrc'"
            :src="slotprops.value.record[slotprops.value.column.key]"
          />
          <p
            v-if="slotprops.value.column.key!='imgSrc' && slotprops.value.column.key !='attachments'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <!-- <p v-if="slotprops.value.column.key=='attachments'">
            <span class="attach-content" v-for="(item, index) in slotprops.value.record[slotprops.value.column.key]" :key="index">
              <img class="atch-img" :src="require('@/assets/garbage.png')" />
              <a class="file-name input-label font-size-14" href="">
                {{item.filename}}</a>
            </span>
          </p>-->
          <!-- v-for="(item, index) in slotprops.value.record[slotprops.value.column.key]" :key="index" -->
          <div v-if="slotprops.value.column.key=='attachments'">
            <!-- <span class="attach-content">
              <img class="atch-img" :src="require('@/assets/ic-attachment.png')" />
              <a href="javascript:void(0)" @click="downloadPayslip(slotprops.value.record)">Payslip</a>
            </span>
            <span class="attach-content">
              <img class="atch-img" :src="require('@/assets/ic-attachment.png')" />
              <a
                href="javascript:void(0)"
                @click="downloadITSheet(slotprops.value.record['id'])"
              >IT Sheet</a>
            </span> -->
            <div  class="downLoadBtn">
              <button @click="postEmpDetailes(slotprops.value.record)" class="export-button">Payslip</button>
              <button @click="DownloadItSheetWithEmpDetailes(slotprops.value.record)" class="export-button">IT Sheet</button>
              <button @click="DownloadItSheetWithExcel(slotprops.value.record)" class="export-button">IT Sheet(Excel)</button>
              <button @click="DownloadYtdWithEmpDetailes(slotprops.value.record)" class="export-button">YTD Report</button>

            </div>
            <!-- <span class="attach-content">
              <img class="atch-img" :src="require('@/assets/ic-attachment.png')" />
              <a href="javascript:void(0)" @click="downloadNewPayslip(slotprops.value.record)">Payslip</a>
            </span>
            <span class="attach-content">
              <img class="atch-img" :src="require('@/assets/ic-attachment.png')" />
              <a
                href="javascript:void(0)"
                @click="downloadNewITSheet(slotprops.value.record)"
              >IT Sheet</a>
            </span> -->
          </div>

          <!-- dropdown section starts here -->
          <!-- <div class="action-section" v-if="slotprops.value.column.key=='action'">
          <a href="http://ec2-13-234-115-126.ap-south-1.compute.amazonaws.com:8081/template/download/employeesalaryregister?id=6ad4b2a3-1f4a-40d6-939c-8e2b789b3675" target="_blank" download=true>Download</a>-->
          <!-- <img src="@/assets/group-2.png" @click="dropdown(slotprops.value)" alt="actionIcon" />
            <ul class="action-menu" v-show="employeeList[slotprops.value.index].showDropDown">
              <li @click="download(slotprops.value.record)">
                <span class>Download</span>
              </li>
              <li @click="sendEmail(slotprops.value.record)">
                <span class>Send Email</span>
              </li>
              <li @click="sendESS(slotprops.value.record)">
                <span class>Send ESS</span>
          </li>-->
          <!-- </ul>
          </div>-->
          <!-- dropdown section ends here -->
        </template>

        <!-- <template v-slot:headercontent="slotprops">
          <div class="action-container">
            <tl-checkbox :checked="true" @change="headerCheckboxChecked()" />
            <button class="export-button" v-on:click="download">Download</button>
            <button class="export-button" v-on:click="sendEmail">Send Email</button>
            <button class="export-button" v-on:click="sendESS">Send ESS</button>
            <div class="action-menu" id="download" v-if="showDownloadableContent">
              <div class="checkbox-content">
                <tl-checkbox label="Payslips" />
              </div>
              <div class="checkbox-content">
                <tl-checkbox label="FBP Payslips" />
              </div>
              <div class="checkbox-content">
                <tl-checkbox label="IT Sheets" />
              </div>
              <div class="dropdown-footer">
                <div class="download-btn">
                  <download-button></download-button>
                </div>
              </div>
            </div>
            <div class="action-menu" id="email" v-if="showSendEmailContent">
              <div class="checkbox-content">
                <tl-checkbox label="Payslips" />
              </div>
              <div class="checkbox-content">
                <tl-checkbox label="FBP Payslips" />
              </div>
              <div class="checkbox-content">
                <tl-checkbox label="IT Sheets" />
              </div>
              <div class="dropdown-footer">
                <div class="download-btn">
                  <btn
                    class="noBorder-btn"
                    text="Send Email"
                    type="secondary"
                    v-on:click="confirmSendEmail"
                  ></btn>
                </div>
              </div>
            </div>
            <div class="action-menu" id="ess" v-if="showSendESSContent">
              <div class="checkbox-content">
                <tl-checkbox label="Payslips" />
              </div>
              <div class="checkbox-content">
                <tl-checkbox label="FBP Payslips" />
              </div>
              <div class="checkbox-content">
                <tl-checkbox label="IT Sheets" />
              </div>
              <div class="dropdown-footer">
                <div class="download-btn">
                  <btn
                    class="noBorder-btn"
                    text="Send ESS"
                    type="secondary"
                    v-on:click="confirmSendESS"
                  ></btn>
                </div>
              </div>
            </div>
          </div>
        </template>-->
      </data-table>
    </div>
    <div v-if="showtable" class="table-div"  @scroll="onScroll()">
      <div class="inside_footer">Please refresh the screen to view the latest status and press the Download button.</div> 
        <data-table :columns="columnNamesForGen" :tableData="bulkPayslipDatas" :showinrow="false">
          <template v-slot:rowcontent="slotprops">
            <div v-if="slotprops.value.column.key == 'download'">
              <button v-if="slotprops.value.record.status !== 'Initiated'"  class="export-button" 
              @click="downloadBulkPayslipsdata(slotprops.value.record)">download</button>
              <div class="reportDownloadRight" v-if="slotprops.value.record.status == 'Initiated'">
              <div @mouseover="downloadBulkPayslipsdetails()"class="loader-container">
                                    <div class="loader"></div>
                                </div>
                              </div>
            </div>
          </template>
        </data-table>
      </div>
    <!-- <bottom-action-container>
      <btn-grp slot="end">
        <btn text="Back" type="secondary" class v-on:click="back"></btn>
      </btn-grp>
    </bottom-action-container> -->

    <!-- Payslip preview modal -->
    <div class="modal custom-modal" v-if="showCreateModal">
      <div class="modal-content modal-sm payslip-modal">
        <div class="modal-header">
          <h3>Payslip Preview</h3>
        </div>
        <div class="modal-body content-center">
          <div>
            <img src="@/assets/preview.png" />
          </div>
          <div class="download-btn">
            <div class="download-btn-container row download-content">
              <div class="rigth-margin-10">
                <img src="@/assets/download.svg" class="img" />
                <span class="text">Download Payslip</span>
              </div>
              <div class="rigth-margin-10">
                <img src="@/assets/download.svg" class="img" />
                <span class="text">Send to Email</span>
              </div>
              <div class="rigth-margin-10">
                <img src="@/assets/download.svg" class="img" />
                <span class="text">Send to ESS</span>
              </div>
              <btn-grp slot="end">
                <btn
                  class="cancel-btn"
                  text="Cancel"
                  type="secondary"
                  v-on:click="cancelPreviewDownload"
                ></btn>
              </btn-grp>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
        </keep-alive>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import {
  criteriaObj,
  monthOptionsObj
} from "../../../../../apis/constants.js";
const crypto = require("crypto");
export default {
  components: {
    SearchDropdown
  },

  data() {
    return {
      categoryOptions:["Department","Location","Cost Centre","Designation","Grade"],
      subCategoryOptions:[],
      subCategory:[],
      subCategoryVisibleFlag:true,
      category:[],
      arrayStoredWithAllCatagoryList:{},
      conditions:{
        location: [],
        grade: [],
        designation: [],
        department: [],
        costCenter: []
      },
      employeeStatus:'active',
      docType: "paySlip",
      costCenter: [],
        employees_status: this.employeeStatus,
        doc_type: this.docType,
        generateBulkText:"Generate Bulk Payslip",
      payrollMonthOptions: [],
      payslipMonthYear: '',
      showtable:false,
      showApplyFilter:false,
      selectedRecordsList: [],
      month: "",
      showModal: false,
      currentMonth: 0,
      filterType: {
        month: null,
        legalEntity: null,
        department: null,
        location: null,
        costCenter: null,
        designation: null
      },
      columnNamesForGen: [
        // {
        //   label: "",
        //   key: "imgSrc"
        // },
        {
          label: "Month",
          key: "month"
        },
        {
          label: "Year",
          key: "year"
        },
        {
          label: "Status",
          key: "status"
        },
        {
          label: "Category",
          key: "catagoryName"
        },
        {
          label: "Sub-Catagory",
          key:"subCategoryName"
        },
        {
          label: "Document Type",
          key: "doc_type"
        },
        {
          label: "",
          key: "download"
        },
      ],
      bulkPayslipDatas: [],
      searchText: "",
      selectedFilterData: {},
      monthOptions: monthOptionsObj.monthListForFinancialYear.sort(
        (a, b) => a.index - b.index
      ),
      selectedArray: [],
      customEmpList: [],
      showDropdown: false,
      showinheader: false,
      showCreateModal: false,
      subCriteriaLabel: "",
      subcriteria: [],
      paygroup: "",
      criteria: "",
      paygroupOptions: [],
      subCriteriaList: [],
      criteriaOptions: criteriaObj.reportCriteria,
      paySlipMonth: "",
      paySlipYear: "",
      showDownloadableContent: false,
      showSendEmailContent: false,
      showSendESSContent: false,
      toast: false,
      monthValue: null,
      errmsg: "",
      sort: "Recently Joined",
      clientCode:"",
      columnNames: [
        // {
        //   label: "",
        //   key: "imgSrc"
        // },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "first_name"
        },
        {
          label: "Department",
          key: "bu_name"
        },
        {
          label: "Email ID",
          key: "email_id"
        },
        {
          label: "Location",
          key: "location_name"
        },
        {
          label: "Attachments",
          key: "attachments"
        }
      ],
      employeeList: [],
      search: "",
      page: 1,
      totalEmployees: 0,
      breadcrumbList: [
        // {
        //   name: "Payslips & IT sheet",
        //   url: ""
        // }
      ],
      paySlipsItSheetsValue: false,
      role: "",
      roleId: "",
      newPayslipMonth: null,
      legalEntityName: null,
    };
  },

  computed: {
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id,
    }),
    ...mapState({
      // payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      // payrollYear: state => state.payroll.runpayroll.payrollYear,
      entities: state => state.onboard.legal_entities.data
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
      if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
        if(this.paySlipsItSheetsValue) {
          return true;
        } else {
          return false;
        }
      }
      // else {
      //   return true
      // }
    }
  },

  activated() {
    this.page = 1;
    this.refresh();
    this.getClientAdminPayrollMonthData();
    this.getPaygroups();
    this.getCurrentMonth();
    this.getOrgLeIdList();
    this.downloadBulkPayslipsdetails();
    this.fetchBulkCatagoryList()
  },
  methods: {
    ...mapActions({
      fetchEmployeeByName: "globalapi/globalemployees/fetchByLeAndName", // PL_2996
      fetchEmployees: "dashboard/payroll/reports/Reports/fetchAll",
      downloadpayslip:
        "dashboard/organisation/utilities/itsheetandpayslip/downloadPayslip",
      itsheet:
        "dashboard/organisation/utilities/itsheetandpayslip/downloadITSheet",
      fetch_paygroups: "onboard/paygroup/fetchAll",
      fetch_locations: "onboard/locations/fetchAll",
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_departments: "onboard/departments/fetchAll",
      fetch_cost_center: "onboard/cost_centres/fetchAll",
      fetch_designation: "onboard/designations/fetchAll",
      act_download_new_payslip: "dashboard/organisation/utilities/itsheetandpayslip/downloadNewPayslips",
      act_download_new_itSheet: "dashboard/organisation/utilities/itsheetandpayslip/downloadNewItsheet",
      act_getProfileData: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchAll',
      act_post_emp_details:"dashboard/organisation/utilities/itsheetandpayslip/postEmpDetails",
      act_download_YTD_report:"dashboard/organisation/utilities/itsheetandpayslip/downloadYtdsheet",
      act_get_client_admin_payroll_data:"dashboard/organisation/utilities/itsheetandpayslip/getClientAdminPayrollMonthList",
      act_get_client_admin_payroll_RL_fine: "dashboard/organisation/utilities/itsheetandpayslip/getClientAdminPayrollMonthListGlobal",
      act_bulk_payslip: "dashboard/organisation/utilities/itsheetandpayslip/downloadBulkPayslips",
      act_bulk_payslip_details: "dashboard/organisation/utilities/itsheetandpayslip/downloadBulkPayslipsdetails",
      act_bulk_payslip_data: "dashboard/organisation/utilities/itsheetandpayslip/downloadBulkPayslipsdata",
      act_get_bulk_catogory:"dashboard/itProof/fetchBulkPayslipSubCatagoryList",
      act_get_bulk_payslip_catogory:"dashboard/itProof/fetchBulkPayslipCatagory",
      act_generate_itsheet_excel:"dashboard/organisation/utilities/itsheetandpayslip/generateItsheetExcel",
    }),
    docTypeChange(){
     if(this.docType == 'paySlip'){
    this.generateBulkText = "Generate Bulk Payslip"}
     else if(this.docType == 'ITSheet'){
      this.generateBulkText = "Generate Bulk IT Sheet"
     }
    },
    async fetchBulkCatagoryList(){
      try{
        //console.log("this.leId",this.leId)
      let res = await this.act_get_bulk_catogory({"le_id":this.leId})
      //console.log("res.data.data",res.data)
      this.arrayStoredWithAllCatagoryList = res.data
      }catch(err){
        throw err
      }
    },
    subCategoryFunction(val){
      if (val.length > 5) {
        this.subCategory = val.slice(0, 5);
        this.toast = true;
        this.errmsg = "You can select a maximum of 5 sub categories.";
      } else {
        this.subCategory = val;
      }
    },
    categoryFunction(val){
      this.category = [val]
      this.subCategoryOptions = []
      this.subCategory = []
      //console.log("this.arrayStoredWithAllCatagoryList",this.arrayStoredWithAllCatagoryList)
      this.category.map(ele=>{
        if(ele == "All"){
          this.category = []
          this.category.push("All")
          this.subCategoryVisibleFlag = false
        }else if(!this.category.includes('All')){
          //console.log("ele",ele)
          this.subCategoryVisibleFlag = true
          if(ele =="Department"){
          this.arrayStoredWithAllCatagoryList['department_name'].map(ele=>{
            this.subCategoryOptions.push(ele)
          })
        } else if(ele =="Location"){
          this.arrayStoredWithAllCatagoryList['based_location_name'].map(ele=>{
            this.subCategoryOptions.push(ele)
          })
        } if(ele =="Cost Centre"){
          this.arrayStoredWithAllCatagoryList['cost_center_name'].map(ele=>{
            this.subCategoryOptions.push(ele)
          })
        } if(ele =="Designation"){
          this.arrayStoredWithAllCatagoryList['designation_name'].map(ele=>{
            this.subCategoryOptions.push(ele)
          })
        } if(ele =="Grade"){
          this.arrayStoredWithAllCatagoryList['grade_name'].map(ele=>{
            this.subCategoryOptions.push(ele)
          })
        }
      }
      })
      //console.log("subCategory",this.subCategory)
        
    },
    segrigadeAllTheCondions(){
      this.conditions = {
        location: [],
        grade: [],
        designation: [],
        department: [],
        costCenter: [],
        employees_status: this.employeeStatus,
      }
      this.category.map(ele=>{
          //console.log("ele",ele,this.subCategory)
          if(ele =="Department"){
            let array =[]
            if(this.subCategory.length ==0){
              //console.log("this.subCategory.length is zero",this.subCategory)
              this.arrayStoredWithAllCatagoryList['department_name'].map(ele=>{
            let res = this.subCategoryOptions.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.department = array
            })
            }else if(this.subCategory.length > 0){
               //console.log("this.subCategory.length",this.subCategory)
              this.arrayStoredWithAllCatagoryList['department_name'].map(ele=>{
              let res = this.subCategory.includes(ele)
              //console.log("Ressssss",res)
               if(res){
                array.push(ele)
               }
             this.conditions.department = array
          })
            }
        
        } else if(ele =="Location"){
          let array =[]
          if(this.subCategory.length ==0){
            this.arrayStoredWithAllCatagoryList['based_location_name'].map(ele=>{
            let res = this.subCategoryOptions.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.location = array
          })
            }else if(this.subCategory.length > 0){
              this.arrayStoredWithAllCatagoryList['based_location_name'].map(ele=>{
            let res = this.subCategory.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.location = array
          })
            }
        } if(ele =="Cost Centre"){
          let array =[]
          if(this.subCategory.length ==0){
            this.arrayStoredWithAllCatagoryList['cost_center_name'].map(ele=>{
            let res = this.subCategoryOptions.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.costCenter = array
          })
            }else if(this.subCategory.length > 0){
              this.arrayStoredWithAllCatagoryList['cost_center_name'].map(ele=>{
            let res = this.subCategory.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.costCenter = array
          })
            }
        
        } if(ele =="Designation"){
          let array =[]
          if(this.subCategory.length ==0){
            this.arrayStoredWithAllCatagoryList['designation_name'].map(ele=>{
            let res = this.subCategoryOptions.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.designation = array
          })
            }else if(this.subCategory.length > 0){
              this.arrayStoredWithAllCatagoryList['designation_name'].map(ele=>{
            let res = this.subCategory.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.designation = array
          })
            }
         
        } if(ele =="Grade"){
          let array =[]
          if(this.subCategory.length ==0){
            this.arrayStoredWithAllCatagoryList['grade_name'].map(ele=>{
            let res = this.subCategoryOptions.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.grade = array
          })
            }else if(this.subCategory.length > 0){
              this.arrayStoredWithAllCatagoryList['grade_name'].map(ele=>{
            let res = this.subCategory.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.grade = array
          })
            }
        }
      })
    },
    // headerCheckboxChecked() {
    //   this.showinheader = false;
    // },

    /* function to get fiancial year */
    getFormattedMonth(val) {
      try {
        this.paySlipMonth = this.monthOptions[new Date(val).getMonth()].name;
        this.monthValue = this.monthOptions[new Date(val).getMonth()].value;
        this.paySlipYear = new Date(val).getFullYear(); // PL_2664
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function get current month */
    getCurrentMonth() {
      try {
        this.month = new Date();
        var today = new Date();
        this.currentMonth = today.getMonth();
        // this.getFormattedMonth(today);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to refresh the page */
    refresh() {
      try {
        this.paygroup = [];
        this.criteria = null;
        this.subcriteria = [];
        this.subCriteriaList = []; // PL_2996
        this.employeeList = [];
        this.subCriteriaLabel = null; // PL_2996
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    getMonthName(month) {
      try {
        switch (month) {
          case "jan":
            this.newPayslipMonth = "January";
            break;
          case "feb":
            this.newPayslipMonth = "February";
            break;
          case "mar":
            this.newPayslipMonth = "March";
            break;
          case "apr":
            this.newPayslipMonth = "April";
            break;
          case "may":
            this.newPayslipMonth = "May";
            break;
          case "jun":
            this.newPayslipMonth = "June";
            break;
          case "jul":
            this.newPayslipMonth = "July";
            break;
          case "aug":
            this.newPayslipMonth = "August";
            break;
          case "sep":
            this.newPayslipMonth = "September";
            break;
          case "oct":
            this.newPayslipMonth = "October";
            break;
          case "nov":
            this.newPayslipMonth = "November";
            break;
          case "dec":
            this.newPayslipMonth = "December";
            break;
          default:
            break;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    getLegalEntityName(value){
      this.entities.map(item => {
        if(value == item.id){
          this.legalEntityName =  item.legalName;
          this.clientCode = item.clientCode;
        }
      })
    },

    async getClientAdminPayrollMonthData (){
      try {
        let res;
        if(this.leId == '2d6f9cc0-be80-48e1-9b62-3d1aad28e8b0' || this.leId == 'fa84a031-adb9-4898-b0e9-7f936f6019b9'){
          res = await this.act_get_client_admin_payroll_RL_fine({le_id : this.leId})
        }else{
          res = await this.act_get_client_admin_payroll_data({le_id : this.leId})
        }
        if(res.status){
          this.payrollMonthOptions = res.data.payload;
          this.payrollMonthOptions = this.payrollMonthOptions.reverse();
          if(this.payrollMonthOptions.length){
            this.payslipMonthYear = this.payrollMonthOptions[0];
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error
      }
    },

    /* server call to download the payslip of an employee */
    async downloadPayslip(empDetails) {
      try {
        let res = await this.downloadpayslip({
          le_id: this.leId,
          empId: empDetails.id, // PL_3042
          org_id: this.orgId,
          paygroup_id: empDetails.paygroup_id, // PL_3042
          financialYear: this.paySlipYear,
          month: this.monthValue // PL_3042
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = "salary details from payroll not available for this month!";
      }
    },

    //Function to download new payslips
    // async downloadNewPayslip(empDetails) {
    //   try{
    //     this.postEmpDetailes(empDetails)
    //     let obj = {
    //       'employee_id': empDetails.id
    //     };
    //     await this.getMonthName(this.monthValue);
    //     await this.getLegalEntityName(this.leId);
    //     let response = await this.act_getProfileData(obj);
    //     this.employeeData = response.data.payload[0];
    //     let payslipObj = {
    //       empCode: this.employeeData.code,
    //       payMonth: this.newPayslipMonth,
    //       clientName: this.legalEntityName,
    //       legalEntityId: this.leId,
    //       clientCode: this.clientCode,
    //       reportType: "pdf",
    //       paymentYear: this.paySlipYear,
    //     }
    //     let data = await this.encryptData(payslipObj);
    //     // let res = await this.act_download_new_payslip(data);
    //     let apiResponse = JSON.parse(await this.decrypt(res.data.data));
    //     const url = apiResponse[0].pdfPreSignedUrl;
    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.setAttribute("download", "Payslip.pdf"); //or any other extension
    //     document.body.appendChild(link);
    //     link.click();
    //   } catch (error) {
    //     this.toast = true;
    //     this.errmsg = "Details not Fetched";
    //   }
    // },
    
    //Function to download new payslips with empDetails
    async postEmpDetailes(empDetails){
      try{
        let obj = {
          'employee_id': empDetails.id
        };
        let response = await this.act_getProfileData(obj);
       let empData = response.data.payload[0];
          let payload={
                        clientName:empData.legalEntityDetails.legalName,
                        type:"paySlip",
                        empCode:empData.code,
                        empId:empData.id,
                        empName:empData.first_name,
                        empPan:empData.pan_number,
                        empGender:empData.gender,
                        empDesigation:empData.designation,
                        empDoj:empData.date_of_joining,
                        empEmail:empData.permanent_address.email,
                        empEsiNum:null,
                        empMobile:empData.mobile_number,
                        empUAN:null,
                        dob:empData.dob,
                        gender:empData.gender,
                        assesmentYear:this.payslipMonthYear.split("-")[1],
                        month:this.payslipMonthYear.split("-")[0],
                        registeredAddress: {
                           email:"",
                           cityID:"",
                           stateID:"",
                           countryID:"",
                           phoneNumber:"",
                           pincode:empData.legalEntityDetails.registeredAddress.pincode,
                           addressLineOne:empData.legalEntityDetails.registeredAddress.addressLineOne,
                           addressLineTwo:empData.legalEntityDetails.registeredAddress.addressLineTwo
                            },
                        logoUrl:empData.legalEntityDetails.logoURL,
                        companyPan:empData.legalEntityDetails.PANNumber,
                        companyTan:empData.legalEntityDetails.TANNumber,
                        location: {
                          
                              id: empData.based_location_id,
                              createdBy: null,
                              updatedBy: null,
                              customAttr: null,
                              le_id: empData.legalEntityDetails.id,
                              industry_type: null,
                              name:null,
                    address: {
                         cityID:empData.communication_address.cityID,
                         pincode: empData.communication_address.pincode,
                         stateID: empData.communication_address.stateID,
                         city_name: empData.communication_address.cityName,
                         countryID: empData.communication_address.countryID,
                         state_name: empData.communication_address.stateName,
                         addressLineOne: empData.communication_address.addressLineOne,
                         addressLineTwo: empData.communication_address.addressLineTwo
        }
    
                        },
                        legalEntity:{
                                     id: empData.legalEntityDetails.id,
                                     name: empData.legalEntityDetails.legalName,
                                     clientCode: empData.legalEntityDetails.clientCode
                                                     }
            

                       }
                let data = await this.encryptData(payload);  
                let res = await this.act_post_emp_details(data)
                let apiResponse = JSON.parse(await this.decrypt(res.data));
                if(apiResponse.data.success){
                const url = apiResponse.data.data.pdfPreSignedUrl;
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Payslip.pdf"); //or any other extension
                document.body.appendChild(link);
                link.click();
                }else{
                  this.toast = true;
                  this.errmsg = apiResponse.data.message;
                }
      }catch(err){
          this.toast = true;
        this.errmsg = err.message;
      }
    },
    //api to download payslips from ess end
    async downloadEssPayslip() {
      try {
        let res = await this.downloadpayslip({
          empId: this.roleId,
          financialYear: this.paySlipYear,
          month: this.monthValue 
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = "salary details from payroll not available for this month!";
      }
    },

    async downloadBulkPayslipsdata(item) {
      try {
        let obj = {
          id: item.id,
        }
        let data = await this.encryptData(obj);
        let res = await this.act_bulk_payslip_data(data);
        let apiResponse = JSON.parse(await this.decrypt(res.data));
        const url = apiResponse.data.pdfPreSignedUrl;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
      }

      catch (error) {
        this.toast = true;
        this.errmsg = "Details not Fetched";
      }
    },
    reloadFunction(){
      location.reload();
    },
    async downloadBulkPayslipsNew() {
      try {
        await this.getLegalEntityName(this.leId);
          if(this.category.length > 0){
            if (this.subCategory.length === 0) {
              this.toast = true;
              this.errmsg = "Please select at least one sub category.";
              return;
            }
        await this.segrigadeAllTheCondions()
          let obj = {
            legalEntityId:this.leId ,
            year: this.paySlipYear,
            leid: this.leId,
            month: this.paySlipMonth,
            client_name: this.legalEntityName,
            client_code: this.clientCode,
            doc_type: this.docType,
            conditions: this.conditions
          }
          console.log("data to back",obj)
          let data = await this.encryptData(obj);
          let res = await this.act_get_bulk_payslip_catogory(data)
          let apiResponse = JSON.parse(await this.decrypt(res.data));
          //console.log("apiResponse",apiResponse)
           this.showModal = true; //PL-2010
           this.responseMessage = apiResponse.message;
      }
      else if(this.category.length == 0){
        this.toast = true;
        this.errmsg = "Please Select Catagory";
      }

      } catch (error) {
        this.toast = true;
        this.errmsg = "Details not Fetched";
      }
    },
    async downloadBulkPayslips() {
      try {
        this.showApplyFilter = false;
        this.showtable = true;
        await this.getLegalEntityName(this.leId);
        const payslipMonthYear = this.payslipMonthYear;
        const year = payslipMonthYear.split("-")[0];
        const monthMap = {
          jan: "January",
          feb: "February",
          mar: "March",
          apr: "April",
          may: "May",
          jun: "June",
          jul: "July",
          aug: "August",
          sep: "September",
          oct: "October",
          nov: "November",
          dec: "December"
        };

        let fullMonthName = monthMap[year] || "Invalid month";
        let obj = {
          legalEntityId: this.leId,
          doc_type: "payslip",
          client_name: this.legalEntityName,
          client_code: this.clientCode,
          month: fullMonthName,
          year: this.payslipMonthYear.split("-")[1]

        }
        let data = await this.encryptData(obj);
        let res = await this.act_bulk_payslip(data);
        let apiResponse = JSON.parse(await this.decrypt(res.data));
        this.showModal = true;
        this.responseMessage = apiResponse.message;
      } catch (error) {
        this.toast = true;
        this.errmsg = "Details not Fetched";
      }
    },

    async downloadBulkPayslipsdetails() {
      try {
        this.showApplyFilter = false;
        this.showtable = true;
        this.showModal = false;
        await this.getLegalEntityName(this.leId);
        let obj = {
          legalEntityId: this.leId,
          "limit": 12,
          "page": 1
        }
        let data = await this.encryptData(obj);
        let res = await this.act_bulk_payslip_details(data);
        let apiResponse = JSON.parse(await this.decrypt(res.data))
        if (apiResponse.data.data) {
          this.bulkPayslipDatas = apiResponse.data.data
          this.bulkPayslipDatas.map((res) => {
            let catagoryName
            let subCategoryName = []
            for (let i in res.conditions) {
              if (res.conditions[i].length) {
                if (i != "employees_status") {
                  catagoryName = i[0].toUpperCase() + i.slice(1).toLowerCase()
                  subCategoryName = res.conditions[i]
                }
              }
            }
            res.catagoryName = catagoryName
            subCategoryName.forEach((word, index, arr) => {
              arr[index] = word[0].toUpperCase() + word.slice(1).toLowerCase()
            })
            res.subCategoryName = subCategoryName.join(", ")

          })
          this.bulkPayslipDatas.forEach(obj => {
            if (obj.doc_type === "paySlip" || obj.doc_type === "Payslip") {
              obj.doc_type = "payslip";
            } else {
              obj.doc_type = "IT Sheet";
            }
            if(obj.status === "INITIATED"){
              obj.status = "Initiated"
            }
            else{
              obj.status = "Completed" 
            }
          });
        }

      } catch (error) {
        this.toast = true;
        this.errmsg = "Details not Fetched";
      }
    },

    getLegalEntityName(value) {
      this.entities.map(item => {
        if (value == item.id) {
          this.legalEntityName = item.legalName;
          this.clientCode = item.clientCode;
        }
      })
    },

    async downloadEssITSheet() {
      try {
        let res = await this.itsheet(
        {
          le_id: this.leId,
          empId: this.roleId, 
          financialYear: this.paySlipYear,
          month: this.monthValue 
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = "salary details from payroll not available for this month!";
      }
    },

    /* server call to download IT Sheet of an employee */
    async downloadITSheet(id) {
      try {
        let res = await this.itsheet(
        {
          le_id: this.leId,
          empId: id, 
          financialYear: this.paySlipYear,
          month: this.monthValue 
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

      //Function to download new ITSheet with empDetails
    async DownloadItSheetWithEmpDetailes(empDetails){
      try{
        let obj = {
          'employee_id': empDetails.id
        };
        let response = await this.act_getProfileData(obj);
       let empData = response.data.payload[0];
          let payload={
                        clientName:empData.legalEntityDetails.legalName,
                        type:"ITSheet",
                        empCode:empData.code,
                        empId:empData.id,
                        empName:empData.first_name,
                        empPan:empData.pan_number,
                        empGender:empData.gender,
                        empDesigation:empData.designation,
                        empDoj:empData.date_of_joining,
                        empEmail:empData.permanent_address.email,
                        empEsiNum:null,
                        empMobile:empData.mobile_number,
                        empUAN:null,
                        dob:empData.dob,
                        gender:empData.gender,
                        assesmentYear:this.payslipMonthYear.split("-")[1],
                        month:this.payslipMonthYear.split("-")[0],
                        registeredAddress: {
                           email:"",
                           cityID:"",
                           stateID:"",
                           countryID:"",
                           phoneNumber:"",
                           pincode:empData.legalEntityDetails.registeredAddress.pincode,
                           addressLineOne:empData.legalEntityDetails.registeredAddress.addressLineOne,
                           addressLineTwo:empData.legalEntityDetails.registeredAddress.addressLineTwo
                            },
                        logoUrl:empData.legalEntityDetails.logoURL,
                        companyPan:empData.legalEntityDetails.PANNumber,
                        companyTan:empData.legalEntityDetails.TANNumber,
                        location: {
                          
                              id: empData.based_location_id,
                              createdBy: null,
                              updatedBy: null,
                              customAttr: null,
                              le_id: empData.legalEntityDetails.id,
                              industry_type: null,
                              name:null,
                    address: {
                         cityID:empData.communication_address.cityID,
                         pincode: empData.communication_address.pincode,
                         stateID: empData.communication_address.stateID,
                         city_name: empData.communication_address.cityName,
                         countryID: empData.communication_address.countryID,
                         state_name: empData.communication_address.stateName,
                         addressLineOne: empData.communication_address.addressLineOne,
                         addressLineTwo: empData.communication_address.addressLineTwo
        }
    
                        },
                        legalEntity:{
                                     id: empData.legalEntityDetails.id,
                                     name: empData.legalEntityDetails.legalName,
                                     clientCode: empData.legalEntityDetails.clientCode
                                                     }
            

                       }
                let data = await this.encryptData(payload);  
                let res = await this.act_post_emp_details(data)
                let apiResponse = JSON.parse(await this.decrypt(res.data));
                if(apiResponse.data.success){
                const url = apiResponse.data.data.pdfPreSignedUrl;
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Payslip.pdf"); //or any other extension
                document.body.appendChild(link);
                link.click();
                }else{
                  this.toast = true;
                  this.errmsg = apiResponse.data.message;
                }
            
      }catch(err){  
        this.toast = true;
        this.errmsg = err.message;
      }
    },
    async DownloadYtdWithEmpDetailes(empDetails){
      try{

        let roleState=localStorage.getItem("userRole")
        if(roleState === "ADMIN"){
          roleState = "ADMIN"  
        }
        else if ( roleState === "EMPLOYEE"){
            roleState = "EMPLOYEE"
        }
        else if ( roleState === "TEAMLEADER"){
            roleState = "ADMIN"
        }
        else if(roleState === "CLIENTADMIN"){
          roleState = "EMPLOYEE"
        }
        let obj={
          empId:empDetails.id,
          financialYear:this.payslipMonthYear.split("-")[1],
          role:roleState,
          month:this.payslipMonthYear.split("-")[0]
        }
        this.showLoader=true;
        let res = await this.act_download_YTD_report(obj);
        this.showLoader=false;
        this.toast=false;
      }
        catch(err){  
        this.toast = true;
        this.errmsg = err.message;
      }
    },
    //Function to download new IT statement
    // async downloadNewITSheet(empDetails) {
    //   try{
    //    this. DownloadItSheetWithEmpDetailes(empDetails)
    //     let obj = {
    //       'employee_id': empDetails.id
    //     };
    //     await this.getMonthName(this.monthValue);
    //     await this.getLegalEntityName(this.leId);
    //     let response = await this.act_getProfileData(obj);
    //     this.employeeData = response.data.payload[0];
    //     let itObj = {
    //       empCode: this.employeeData.code,
    //       month: this.newPayslipMonth,
    //       clientName: this.employeeData.first_name,
    //       reportType: "pdf",
    //       assesmentYear: this.month.split("-")[1],
    //       clientCode: this.employeeData.legalEntityDetails.clientCode,
    //       legalEntityId: this.employeeData.legal_entity_id
    //     }
    //     let data = await this.encryptData(itObj);
    //     // let res = await this.act_download_new_itSheet(data);
    //     let apiResponse = JSON.parse(await this.decrypt(res.data.data));
    //     const url = apiResponse.pdfPreSignedUrl;            
    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.setAttribute("download", "It Sheet.pdf"); //or any other extension
    //     document.body.appendChild(link);
    //     link.click();
    //   } catch (error) {
    //     this.toast = true;
    //     this.errmsg = "Details not Fetched";
    //   }
    // },

    async encryptData(payload) {
      try {
        const iv = crypto.randomBytes(8).toString('hex')
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const cipher = crypto.createCipheriv('aes-256-cbc', key, iv);
        let encryptedText = Buffer.concat([
          cipher.update(JSON.stringify(payload)),
          cipher.final()
        ]);
        return {
          iv: iv.toString(),
          encryptedPacket: encryptedText.toString('base64')
        }
      } catch (err) {
        throw err;
      }
    },

    async decrypt(payload) {
      try {
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const decipher = crypto.createDecipheriv('aes-256-cbc', key, payload.iv);
        const decrypted = Buffer.concat([decipher.update(payload.encryptedPacket, 'base64'), decipher.final()]);
        return decrypted.toString();
      } catch (error) {

      }
    },

    async DownloadItSheetWithExcel(empDetails) {
      try {
        let data = {
          leId: this.leId,
          month: this.payslipMonthYear.split("-")[0],
          year: this.payslipMonthYear.split("-")[1],
          empCode: empDetails.code
        }
        let response = await this.act_generate_itsheet_excel(data);
        if(response && response.data && response.data.data ) {
          const url = response.data.data.data;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Payslip.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
      } catch (error) {
        let err = error.response.data;
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    // dropdown(slots) {
    //   try {
    //     let idx = this.employeeList.findIndex(obj => {
    //       return obj.empId == slots.record.empId;
    //     });

    //     this.employeeList.forEach((data, index) => {
    //       if (index != idx) {
    //         data.showDropDown = false;
    //       }
    //     });
    //     if (idx > -1) {
    //       this.employeeList[slots.index].showDropDown = !this.employeeList[
    //         slots.index
    //       ].showDropDown;
    //     }
    //   } catch (error) {
    //     this.toast = true;
    //     this.errmsg = error;
    //   }
    // },

    /* server call to get employees by name */
    // Start PL_2996
    async getEmployeesByName(val) {
      try {
        if (val.length >= 3) {
          let res = await this.fetchEmployeeByName({
            key: val,
            le_id: this.leId
          });
          if (res.data.payload) {
            this.customEmpList = res.data.payload;
          }
        } else {
          this.customEmpList = [];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    // End PL_2996

    /* function to select employee */
    selectedEmp(val) {
      this.employeeList = [val];
      this.totalEmployees = this.customEmpList.length; // PL_2996
    },

    /* function to get subcriteria after changing criteria */
    onSelectCriteria(event) {
      this.subcriteria = [];
      try {
        if (event == "Location") {
          this.subCriteriaLabel = "Location";
          this.getLocations();
        } else if (event == "Cost Centre") {
          this.subCriteriaLabel = "Cost Centre";
          this.getCostCenter();
        } else if (event == "Band") {
          this.subCriteriaLabel = "Band";
          this.getBands();
        } else if (event == "Grade") {
          this.subCriteriaLabel = "Grade";
          this.getGrades();
        } else if (event == "Department") {
          this.subCriteriaLabel = "Department";
          this.getDepartments();
        } else {
          this.subCriteriaLabel = "Sub Criteria";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Locations */
    async getLocations() {
      try {
        let res = await this.fetch_locations(this.leId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Salary bands */
    async getBands() {
      try {
        let res = await this.fetch_bands(this.leId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Paygroups */
    async getPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.leId);
        if (res.data.status) {
          this.paygroupOptions = res.data.payload.data;
          this.paygroup = this.paygroupOptions[0];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Departments */
    async getDepartments() {
      try {
        let res = await this.fetch_departments(this.leId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Cost centres */
    async getCostCenter() {
      try {
        let res = await this.fetch_cost_center(this.leId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Salary grades */
    async getGrades() {
      try {
        let res = await this.fetch_grades(this.leId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to apply filters */
    applyFilters() {
      this.showtable = false;
      this.showApplyFilter = true;
      this.page = 1;
      this.employeeList = [];
      this.getEmployeesByApplyingFilter();
    },

    /* server call to get employees after selcting filter options */
    async getEmployeesByApplyingFilter() {
      try {
        console.log("this.payslipMonthYear",this.monthValue,this.payslipMonth)
        let obj = {
          le_id: this.leId,
          financial_year: this.paySlipYear,
          month: this.monthValue,
          bands:
            this.criteria == "Band"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          bunits:
            this.criteria == "Department"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          cost_centers:
            this.criteria == "Cost Centre"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          locs:
            this.criteria == "Location"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          paygroups: this.paygroup.length
            ? this.paygroup.map(item => {
                return item.id;
              })
            : []
        };
        let res = await this.fetchEmployees({ obj: obj, page: this.page });
        if (res.data.payload) {
          let dataArr = res.data.payload.data;
          this.totalEmployees = res.data.payload.totalEmpCount;
          dataArr.forEach(element => {
            if(!this.employeeList.some(item => item.id == element.id)){
              this.employeeList.push(element);
            }
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to get employees on scroll */
    onScroll() {
      let bottomOfWindow =
        this.$refs.table_div.scrollHeight - this.$refs.table_div.scrollTop <=
        this.$refs.table_div.offsetHeight;
      if (bottomOfWindow && this.employeeList.length < this.totalEmployees) {
        this.page += 1;
        this.getEmployeesByApplyingFilter();
      }
    },


    /* function to back to utilitie page */
    back() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
      });
    },
    // cancelPreviewDownload() {
    //   this.showCreateModal = false;
    // },
    // download() {
    //   try {
    //     this.showDownloadableContent = !this.showDownloadableContent;
    //     this.showSendESSContent = false;
    //     this.showSendEmailContent = false;
    //   } catch (error) {
    //     this.toast = true;
    //     this.errmsg = error;
    //   }
    // },

    // sendEmail() {
    //   try {
    //     this.showDownloadableContent = false;
    //     this.showSendEmailContent = !this.showSendEmailContent;
    //     this.showSendESSContent = false;
    //   } catch (error) {
    //     this.toast = true;
    //     this.errmsg = error;
    //   }
    // },
    // sendESS() {
    //   try {
    //     this.showDownloadableContent = false;
    //     this.showSendEmailContent = false;
    //     this.showSendESSContent = !this.showSendESSContent;
    //   } catch (error) {
    //     this.toast = true;
    //     this.errmsg = error;
    //   }
    // },
    // confirmSendEmail() {},
    // confirmSendESS() {},

   ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgIds;
        const le = this.leId;
        ////console.log("Org:",org);
        ////console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.roleId = data.data.user.employee_id;
        this.paySlipsItSheetsValue = data.data.user.permissions.payslips_it_sheets ? true : false;
        ////console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped >

.inside_footer{
  margin-bottom: 5px;
  font-weight: 500;
  color: red;
  font-weight: 700;

}
.filterButton{
  display: flex;
  align-items: center;
  padding: 0;
}
.fnfbtn {
  width: 135px;
  align-self: flex-start;
  background-color: #ffffff;
  border: #34c0be solid 1px;
  color: #34c0be;
  font-weight: bold;
  padding: 10px 10px;
  border-radius: 4px;
}
.table-div {
  height: 342px;
  overflow: auto;
}
.attachment {
  font-size: 14px;
  margin-top: -24px;
}

.text-right {
  text-align: center;
}

.checkbox-content {
  &:not(:last-child) {
    margin-bottom: 10px;
  }
}
.noBorder-btn {
  border: none !important;
  min-height: 0px !important;
  padding: 0px !important;
}
.content {
  margin-left: 20px;
  margin-top: 15px;
}

.main-header {
  color: #6d6d6d;
  margin-top: 25px;
  font-size: 16px;
}

.sort-by {
  display: flex;
  margin-left: 8%;
  span {
    margin-right: 10px;
    margin-top: 10px;
    color: #b3b3b3;
    font-size: 12px;
  }
}

.searchsort {
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 10px;
  .sorttext {
    text-align: center;
    line-height: 30px;
    color: #726f75;
    padding: 0px 0px 0px 10px;
    margin-left: auto;
  }
}

.customwidth {
  width: 200px;
  margin-top: 0px;
}

.atch-img {
  width: 2%;
}

.download-btn-container {
  display: flex;
  align-items: flex-end;
  .img {
    width: 16px;
    object-fit: contain;
  }
  .text {
    font-size: 10px;
    color: #34c0be;
    margin-left: 5px;
  }
}

.download-btn {
  margin-top: 2%;
}

.file-name {
  padding: 0px 5px;
}

.rigth-margin-10 {
  margin-right: 10px;
}

.content-center {
  justify-content: center;
  text-align: center;
}

.employeeDownload{
  margin-top: 20px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(5, 5, 5, 0.08) 0px 0px 0px 1px;
  border-radius: 2%;
  width:max-content;
  padding: 10px;
  cursor: pointer;
}

.downloadImg{
  margin-right: 10px;
}

.downloadText{
  color: #34c0be;
  font-weight: bold;
}

.download-content {
  justify-content: flex-end !important;
  text-align: center;
  align-items: center !important;
}

.attach-content {
  color: #6e6e6e !important;
  a {
    margin-left: 4px;
    margin-right: 15px;
    font-size: 14px;
    position: relative;
    top: -6px;
  }
}

.font-size-14 {
  font-size: 14px !important;
} // table header designs
.tableheader {
  display: flex;
  align-items: center;
  .action-dropdown {
    display: block;
    cursor: pointer;
    opacity: 0.1;
    position: relative;
  }
  &:hover {
    .action-dropdown {
      opacity: 1;
    }
  }
} // try
.action-container {
  position: absolute;
  display: flex;
}

.reportDownloadLeft {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 5px
}

.reportDownloadLeft>span {
    color: #444444;
    font-weight: 500;
}

.reportDownloadLeftTextField {
    width: 180px;
    text-transform: capitalize;
    margin-top: -8px;
}

.action-menu {
  width: 175px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.23);
  background-color: #ffffff;
  margin-right: 10px;
  z-index: 1;
  padding: 20px 10px;
  position: absolute;
  top: 144%;
  padding-bottom: 10px;

  &::before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    top: -10px;
    right: 30%;
    filter: drop-shadow(1mm 0mm 0mm rgba(0, 0, 0, 0.23));
  }

  &#download {
    margin-left: 0px;
  }
  &#email {
    margin-left: 100px;
  }
  &#ess {
    margin-left: 200px;
  }
  .edit {
    cursor: pointer;
    margin-left: 5px;
    font-size: 12px;
    color: #616363;
    margin-bottom: 10px;
  }
  .query {
    cursor: pointer;
    margin-left: 3px;
    font-size: 12px;
    color: #616363;
  }
  .joining {
    cursor: pointer;
    margin-left: 2px;
    font-size: 12px;
    color: #616363;
  }
  .dropdown-footer {
    border-top: 1px solid #d6d4d4;
  }
}

.export-button {
  padding: 0px 5px !important;
  margin: 0px 5px !important;
  width: 100px !important;
  margin-top: -5px !important;
}

.action-section {
  margin: 0px;
  text-align: center;

  img {
    width: auto;
  }
  .action-menu {
    top: 0%;
    left: -140%;
    width: max-content;
    padding-top: 5px;
    padding-bottom: 5px;
    li {
      padding: 0px;
      font-weight: 500;
      span {
        margin: 0px 20px;
        padding: 10px;
        display: block;
      }
      &:not(:last-child) {
        span {
          border-bottom: solid 1px #97979759;
        }
      }
    }
  }
}
.payslip-modal {
  width: 60% !important;
  height: 90% !important;
  margin: 60px auto 0px auto !important;
}

.cancel-btn {
  display: block;
  border-radius: 4px;
  background-color: #ffffff;
  border: #34c0be solid 1px;
  color: #34c0be;
  font-weight: bold;
  min-width: 60px;
  padding: 14px;
  font-size: 14px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
.downLoadBtn{
    display: flex;
    gap:20px
 }
 .export-button{
    background-color:  rgba(14, 165, 235, 0.5);
    color: black;
    width: 6rem;
    height:2rem;
 }
 .loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  
}

.loader {
  border: 2px solid #f3f3f3;
  border-top: 3px solid #34c0be;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  animation: spin 1s linear infinite;
  
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.styleReport{
padding: 5px 52px 5px 10px !important;
}
.reportDownloadRight {
    display: flex;
    align-items: center;
    gap: 10px;
    background-color:#ffffff;
    border: #34c0be solid 1px;
    color: #ffffff;
    border-radius: 4px;
    font-weight: bold;
    max-width: 135px;
    //max-height: 30px;
    text-align: center;
    padding: 5px 10px;
    margin-top: 6px;
    cursor: pointer;
    margin-right: 20px;
}
.dropDownClass{
  display:flex;
}
.tl-select{
    width:320px;   
  }
  .buttonsClass{
    display: flex;
    margin:30px 0px;
  }
</style>
